import { DOMAIN_LIST } from "@/services/constants/global";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Select,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function EmailInputFormWithDomainSelecter({
  formLabel = "Email",
  name = "email",
  value,
  setValue,
  error,
  touched,
  gap = 3,
}) {
  const { t } = useTranslation();
  const [selectedDomain, setSelectedDomain] = useState("");

  const onSelectDomain = (domain) => {
    let emailAddress = value;
    const domainIndex = emailAddress.indexOf("@");
    if (domainIndex < 0) {
      emailAddress = emailAddress + "@" + domain;
    } else {
      const currentDomain = emailAddress.substring(domainIndex);
      emailAddress = emailAddress.replace(currentDomain, "@" + domain);
    }
    setSelectedDomain(domain);
    setValue(name, emailAddress);
  };

  const onChangeEmail = (email) => {
    const domainIndex = email.indexOf("@");
    const selectingDomain = email.substring(domainIndex + 1);
    setSelectedDomain(selectingDomain);
    setValue(name, email);
  };

  return (
    <HStack gap={gap} align="flex-end">
      <FormControl isRequired isInvalid={touched && error}>
        <FormLabel htmlFor={name}>{t(formLabel)}</FormLabel>
        <Input
          flexGrow={1}
          id={name}
          name={name}
          type="text"
          placeholder={t("Enter your email")}
          onChange={(event) => onChangeEmail(event.target.value)}
          value={value}
        />
        <FormErrorMessage h={6}>{error}</FormErrorMessage>
      </FormControl>
      <Select
        h={10}
        placeholder={`${t("Select Email")}`}
        onChange={(event) => onSelectDomain(event.target.value)}
        value={selectedDomain}
        mb={touched && error ? 8 : 0}
      >
        {DOMAIN_LIST.map((domain) => (
          <option key={domain} value={domain}>
            {domain}
          </option>
        ))}
      </Select>
    </HStack>
  );
}
